import React from 'react';
import { DateInput, RadioButtonGroupInput, useTranslate } from 'react-admin';
import { MAINTENANCE, SLUDGE_EMPTYING } from '../../../utils/rikutec';
import { Box } from '@material-ui/core';
import './PeriodInput.css';

const PeriodInput = (props: { source: string; label: string; classes?: any }) => {
    const translate = useTranslate();

    return (
        <Box className='period-filter-installation-date'>
            <DateInput
                size={'medium'}
                {...props}
                label={translate('app.common.after')}
                variant={'standard'}
                classes={props.classes}
                // source={`${props.source}[createdAt_after]`}
                // source={`${props.source}%5BcreatedAt_after%5D`}
                source={`${props.source}__createdAt_after`}
            />

            <DateInput
                size={'medium'}
                {...props}
                variant={'standard'}
                label={translate('app.common.before')}
                classes={props.classes}
                // source={`${props.source}%5BcreatedAt_before%5D`}
                source={`${props.source}__createdAt_before`}
            />

            <RadioButtonGroupInput
                size={'medium'}
                helperText={false}
                label={''}
                classes={props.classes}
                // source={`${props.source}%5Btags%5D`}
                source={encodeURI(`${props.source}__tags`)}
                choices={[
                    {
                        id: SLUDGE_EMPTYING,
                        name: translate(`app.ancs.${SLUDGE_EMPTYING}`),
                    },
                    {
                        id: MAINTENANCE,
                        name: translate(`app.ancs.${MAINTENANCE}`),
                    },
                ]}
            />
        </Box>
    );
};

export default PeriodInput;
